/**
 * No modo "Próximos dias" a tela fica só com a previsão sobre o satélite do
 * Google (pedido do usuário, 18/10/2026): ao entrar, TODAS as camadas
 * observadas são desligadas pelos próprios interruptores (o trilho do desktop
 * e o do celular ficam desmarcados); ao sair, volta exatamente o que estava
 * ligado — e o que a pessoa ligou durante o modo desliga de novo.
 *
 * O observado não perde nada: os interruptores religam com a mesma seleção
 * (sub-produtos, fontes, camadas do mapa), e o link e as preferências ficam
 * congelados no estado de antes (`congelarCodecs`) — recarregar no modo, ou
 * fechar a aba, não grava as camadas desligadas. Ficam vivos só o enquadramento
 * (`c`, `z`), a busca (`b`) e os da própria previsão (`y`, `d`, `l`, `o`).
 */
import { congelarCodecs } from '../state/urlSync';
import { getPanels } from '../ui/panels';
import { aoMudarModo, emModoPrevisao } from './store';

const MANTER: ReadonlySet<string> = new Set(['c', 'z', 'b', 'y', 'd', 'l', 'o']);

/** Liga a limpeza ao modo; devolve a função que desfaz (e religa o observado, se no modo). */
export function iniciarLimpeza(): () => void {
  let antes: Map<string, boolean> | null = null;
  let descongelar: (() => void) | null = null;

  const entrar = () => {
    if (antes) return;
    // Primeiro congela: o link e as preferências guardam as camadas ainda ligadas.
    descongelar = congelarCodecs(MANTER);
    antes = new Map();
    for (const p of getPanels()) {
      if (!p.layer) continue;
      const ligada = p.layer.isOn();
      antes.set(p.id, ligada);
      if (ligada) p.layer.setOn(false);
    }
  };

  const sair = () => {
    if (!antes) return;
    for (const p of getPanels()) {
      if (!p.layer) continue;
      const ligada = antes.get(p.id) ?? false;
      if (p.layer.isOn() !== ligada) p.layer.setOn(ligada);
    }
    antes = null;
    descongelar?.();
    descongelar = null;
  };

  const parar = aoMudarModo((modo) => (modo ? entrar() : sair()));
  if (emModoPrevisao()) entrar();
  return () => {
    parar();
    sair();
  };
}
